module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('district-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.district.name
    },
    model: {
      value: (_vm.$attrs.district.name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.district, "name", $$v)
      },
      expression: "$attrs.district.name"
    }
  }), _vm._v(" "), _c('city-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.district.city)),
      expression: "!(formType == 'add' && $attrs.district.city)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.district.city
    },
    model: {
      value: (_vm.$attrs.district.city),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.district, "city", $$v)
      },
      expression: "$attrs.district.city"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c987b6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/district/DistrictBlankForm.vue
// module id = 638
// module chunks = 0